import React from "react";
import { useSelector } from "react-redux";
import { getToolTip } from "../../../../utils/getToolTip";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const NetUnits = ({ qa }) => {
  const { netUnitsMTD, netUnitsMTDLink, netUnitsMTDChange } =
    useSelector((state) => state.membershipUnits.membershipUnits.units);

  const state = useSelector((state) => state.membershipUnits.membershipUnits);
  const toolTip = getToolTip(state);

  return (
    <>
      <div className="content__el">
        <SectionContainer
          title="Net Units MTD"
          toolTip={toolTip}
          toolTipId="membershipNewUnitsToolTipMTD"
        >
          <DataDisplay
            type="number"
            value={netUnitsMTD}
            url={netUnitsMTDLink}
            disableAnimation={qa}
            toolTipContent={toolTip}
            toolTipId="membershipNewUnitsToolTipMTD"
            changeProps={{
              changeValue: netUnitsMTDChange,
              toolTip: "Percentage change from previous month",
              showBorder: true
            }}
          />
        </SectionContainer>
      </div>
    </>
  );
};

export default NetUnits;
